import { SvgIcon, SvgIconProps } from '@mui/material';

function DragIcon(props: SvgIconProps) {
    return (
        <SvgIcon {...props}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    id="Vector"
                    d="M1.5 1.5H18.5M1.5 7H18.5M1.5 12.5H18.5"
                    stroke="#926EC4"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
        </SvgIcon>
    );
}

export default DragIcon;
